import api from "../services/api";
import { Permissao } from "../types/permissao.type";

export interface Usuario {
  id: number;
  nome: string;
  email: string;
  ativo: boolean;
  isAdmin: boolean;
  cargos?: { id: number; nome: string }[];
permissoes?: Permissao[];

}

export interface CreateUsuarioDTO {
  nome: string;
  email: string;
  senha?: string;
  ativo?: boolean;
  isAdmin?: boolean;
  cargoIds?: number[];
  permissaoIds?: number[];

}

export type UpdateUsuarioDTO = Partial<CreateUsuarioDTO>;

class UsuarioService {
  async listar(): Promise<Usuario[]> {
    const response = await api.get('/usuarios');
    return response.data;
  }

  async buscarPorId(id: number): Promise<Usuario> {
    const response = await api.get(`/usuarios/${id}`);
    return response.data.data;
  }

  async criar(data: CreateUsuarioDTO): Promise<Usuario> {
    const response = await api.post('/usuarios', data);
    return response.data.data;
  }

  async atualizar(id: number, data: UpdateUsuarioDTO): Promise<Usuario> {
    const response = await api.put(`/usuarios/${id}`, data);
    return response.data.data;
  }

  async excluir(id: number): Promise<void> {
    await api.delete(`/usuarios/${id}`);
  }
}

export const usuarioService = new UsuarioService();

export {};
